/*
 * @providesModule FastMatchController
 *
 */

const FastMatchController = {
  showStakesSelection: () => undefined,
  getStakesSelectText: async () => undefined,
};

export default FastMatchController;
